import {Hydra} from '../generic/hydra';

import {AdresseInterface} from './Adresse';
import {PersonneInterface} from './Personne';
import {LaboratoireReferenceSuggestionInterface} from './LaboratoireReferenceSuggestion';
import {LaboratoireReference as LaboratoireReferenceBaseInterface} from '../../interface/api/LaboratoireReference';

export type LaboratoireReferenceInterface = LaboratoireReferenceBaseInterface;

export class LaboratoireReference extends Hydra implements LaboratoireReferenceInterface {

    id?: number | null;

    label?: string | null;

    /* Unité, service, Laboratoire, Equipe
     */
    division?: string | null;

    sigle?: string | null;

    /* 0 = a valider, 1 = validé, 2 = rejeté/désactivé, 3 = hors france
     */
    etat?: number | null = 0;

    /* Objet de type Adresse
     */
    adresse?: AdresseInterface | null;

    /* Objet de type Personne
     */
    directeur?: PersonneInterface | null;

    dateCreation?: string | Date | null;

    dateDerniereModification?: string | Date | null;

    CLCC?: boolean | null;

    APHP?: boolean | null;

    laboratoireReferenceSuggestions?: LaboratoireReferenceSuggestionInterface[] | string[] | null = [];

    canceropole?: string | null;

    enabled?: boolean | null;


    constructor(options: LaboratoireReferenceInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
